import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const shortcut = defineConnector({
  identifier: "shortcut",
  name: "Shortcut",
  tagLine: "Project management for software teams",
  keywords:
    "clubhouse stories epics iterations tickets bugs issues project management",
  logo,
  protocol: "http",
  tags: ["productivity", "engineering"],
  defaultUrlPattern: () => "https://api\\.app\\.shortcut\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Shortcut-Token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Shortcut](https://app.shortcut.com/), go to **Settings → API Tokens** and generate a new token.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.app.shortcut.com/api/v3/categories",
  },
});
